<template>
  <div class="PublicityDetail4">    
    <h3>汇聚金融力量共创美好生活</h3>
    <div>为了响应“汇聚金融力量共创美好生活”，我司积极开展”五进入”活动精准宣传。</div>
    <br/>
    <div>本次活动展开“进企业”开展“金融知识进商圈”活动，提升活动覆盖面、影响力。针对非法吸存揽储、养老领域金融诈骗、电信网络诈骗、非法代理维权等内容，开展消费者风险提示工作，通过正面宣传，反面警示，提升消费者与投资者风险防范意识</div>
    <img :src="require('../images/ic_publicity_detail4_1.jpeg')"/>
    <br/>
    <img :src="require('../images/ic_publicity_detail4_2.jpeg')"/>
    <br/>
    <div>员工内部进行普及金融知识，传播金融正能量的会议培训，坚守诚信经营底线，规范自身营销宣传行为，改进产品服务展示方式，在产品设计、产品销售、提供 服务等环节加强评估和监测，排查侵害消费者权益行为，确保将合适的产品通过合适的渠道销售给合适的消费者。同时倡导消费者讲诚信、守底线，培养良好的金融消费习惯和健康文 明的网络行为习惯，不传播金融谣言，通过正规渠道依法理 性维护自身权益，警惕非法“代理维权”陷阱，强化风险责 任意识和诚信契约精神。推动诚实守信成为金融机构、金融 从业人员和消费者的自觉行为规范，促进行业诚信意识进一步增强，诚信文化建设扎实落地，行业信用环境持续改善，营造守信互信、共践共行的良好网络氛围。</div>
    <br/>
    <img :src="require('../images/ic_publicity_detail4_3.jpeg')"/>
    <br/>
    <img :src="require('../images/ic_publicity_detail4_4.jpeg')"/>
  </div>
</template>

<script>
export default {
  name: 'PublicityDetail4'
};
</script>

<style scoped lang="less">
.PublicityDetail4 {
  width: 100%;
  box-sizing: border-box;
  font-size: 18px;
  line-height: 32px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  h3 {
    font-weight: bold;
    font-size: 28px;
    line-height: 52px;
    align-self: center;
  }

  .title {
    font-weight: bold;
    font-size: 24px;
    line-height: 45px;
  }

  .subtitle {
    font-size: 20px;
    line-height: 40px;
    font-weight: 500;
    text-indent: 2em;

    &.no-indent {
      text-indent: unset;
    }
  }

  div {
    text-align: left;
  }

  p {
    text-indent: 2em;
    margin: 15px 0 0;
    text-align: left;
    margin-block-end: 0;
    margin-block-start: 0;
  }

  img {
    width: 50%;
    margin-top: 30px;
    align-self: center;
  }

  p + img,
  .subtitle + img {
    margin-left: 2em;
  }

  img + p {
    margin-top: 15px;
  }

  img + .title,
  p + .title {
    margin-top: 60px;
  }

  .title + .subtitle,
  img + .subtitle {
    margin-top: 15px;
  }

  p + .subtitle {
    margin-top: 45px;
  }
}
</style>
